import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
// import TasksProgressBarContainer from "../TasksProgressBarContainer/TasksProgressBarContainer";
import SubtasksTable from "../../components/tasks/SubtasksTable/SubtasksTable";
import { fetchSubtasks, fetchTaskStatus } from "../../store/slices/tasks";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import TasksProgress from "../../components/tasks/TasksProgressBar/TasksProgress";
import { getUserById } from "../../store/slices/users";

interface ISubtasksTableContainer {
  taskId: number | null;
  setTaskIdForReprocess: any;
  setIsModalConfirmationVisible: any;
  subtasksStatusForFetching: number;
  subTasksCurrentPage: number;
  setSubTasksCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

function SubtasksTableContainer(props: ISubtasksTableContainer) {
  const {
    taskId,
    setIsModalConfirmationVisible,
    setTaskIdForReprocess,
    subtasksStatusForFetching,
    subTasksCurrentPage,
    setSubTasksCurrentPage,
  } = props;
  const {
    subtasks,
    subtasksLoading,
    taskStatus,
    taskStatusLoading,
    task,
    taskLoading,
    // @ts-ignore
  } = useSelector((state) => state.tasks);
  const {
    user,
    userLoading,
    // @ts-ignore
  } = useSelector((state) => state.users);
  const dispatch = useDispatch();

  const [tasksCount, setTasksCount] = useState<number>(0);
  const [finishedSubtasks, setFinishedSubtasks] = useState<number>(0);
  const [successSubtasks, setSuccessSubtasks] = useState<number>(0);
  const [failedSubtasks, setFailedSubtasks] = useState<number>(0);
  const [taskStatusId, setTaskStatusId] = useState<number>(0);
  const isActiveTask = taskStatusId === 2;

  const countFinishedTasks = (obj: {}) => {
    let count = 0;

    Object.keys(obj).forEach((item) => {
      if (item !== "2") {
        count += obj[item];
      }
    });
    return count;
  };

  useEffect(() => {
    dispatch(
      // @ts-ignore
      fetchSubtasks({ taskId, status: subtasksStatusForFetching, page: subTasksCurrentPage - 1 })
    );
  }, [taskId, subTasksCurrentPage]);

  useEffect(() => {
    if (checkIsLoaded(taskLoading)) {
      // @ts-ignore
      dispatch(getUserById(task.userId));
    }
  }, [dispatch, task, taskLoading]);

  useEffect(() => {
    if (checkIsLoaded(taskStatusLoading)) {
      setFinishedSubtasks(countFinishedTasks(taskStatus.subTasks.countByStatus));
      setTasksCount(taskStatus.subTasks.count);
      setSuccessSubtasks(
        taskStatus.subTasks.countByStatus["3"] ? taskStatus.subTasks.countByStatus["3"] : 0
      );
      setFailedSubtasks(
        taskStatus.subTasks.countByStatus["4"] ? taskStatus.subTasks.countByStatus["4"] : 0
      );
      setTaskStatusId(taskStatus.statusId);
    }
  }, [taskStatus, taskStatusLoading, tasksCount]);

  useEffect(() => {
    if (isActiveTask) {
      const interval = setInterval(() => {
        // @ts-ignore
        dispatch(fetchTaskStatus({ taskId }));
      }, 5000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isActiveTask, taskStatusId]);

  useEffect(() => {
    // @ts-ignore
    dispatch(fetchTaskStatus({ taskId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Spin spinning={checkIsLoading(subtasksLoading, userLoading)}>
      <TasksProgress
        tasksCount={tasksCount}
        finishedSubtasks={finishedSubtasks}
        successSubtasks={successSubtasks}
        failedSubtasks={failedSubtasks}
        taskStatusId={taskStatusId}
        initiator={
          checkIsLoaded(userLoading)
            ? `${user?.userInfo?.firstName} ${user?.userInfo?.lastName}`
            : "undefined"
        }
        createDate={task.createDate}
        changeDate={task.changeDate}
        statusDescription={task.statusDescription}
      />
      <SubtasksTable
        setIsModalConfirmationVisible={setIsModalConfirmationVisible}
        setTaskIdForReprocess={setTaskIdForReprocess}
        subtasks={subtasks}
        subtasksLoading={subtasksLoading}
        subTasksCurrentPage={subTasksCurrentPage}
        setSubTasksCurrentPage={setSubTasksCurrentPage}
      />
    </Spin>
  );
}

export default SubtasksTableContainer;
